export abstract class Validator<T, U = boolean> {
  abstract isValid(input: T): U;
}
